import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import Input from '@/components/common/Input';
import Button from '@/components/common/Button';

export default function ForgotPasswordPage() {
  const { forgotPassword, error, clearError } = useAuth();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    setIsSubmitting(true);
    try {
      await forgotPassword(email);
      setSubmitted(true);
    } catch {
      // Error is set in the hook
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="space-y-4 text-center">
        <h2 className="text-xl font-semibold text-neutral-900">Check Your Email</h2>
        <p className="text-sm text-neutral-600">
          If an account exists for <strong>{email}</strong>, we've sent a password reset code.
        </p>
        <Link to="/reset-password">
          <Button className="w-full">Enter Reset Code</Button>
        </Link>
        <Link to="/login" className="block text-sm text-primary-600 hover:text-primary-700">
          Back to Sign In
        </Link>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="text-xl font-semibold text-neutral-900">Forgot Password</h2>
      <p className="text-sm text-neutral-600">
        Enter your email address and we'll send you a code to reset your password.
      </p>

      {error && (
        <div className="rounded-lg bg-error-50 p-3 text-sm text-error-700" role="alert">
          {error}
        </div>
      )}

      <Input
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        required
        autoComplete="email"
      />

      <Button type="submit" className="w-full" loading={isSubmitting}>
        Send Reset Code
      </Button>

      <Link
        to="/login"
        className="block text-center text-sm text-primary-600 hover:text-primary-700"
      >
        Back to Sign In
      </Link>
    </form>
  );
}
